<template>
  <div class="bilingual-news">
    <BackToTop />
    <div class="container">
      <div class="main">
        <div class="main_left">
          <el-tabs v-model="activeName" @tab-click="handleClick" ref="tabs">
            <el-tab-pane
              v-for="(item) in topClassList"
              :key="item.id"
              :label="item.name"
              :name="String(item.id)"
              :lazy="false"
            >
              <div class="main_left_item">
                <img :src="getFullUrl(coverImgMap[item.id])" alt="" />
                <div class="fu_text" v-html="richTextContent[item.id]"></div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="main_right">
          <div
            class="plate_right_item"
            v-for="item in classSonList"
            :key="item.id"
          >
            <div class="plate_right_item_title">
              <span>{{ item.name }}</span>
            </div>
            <div
              class="plate_right_item_content"
              @click="goToClassSon(item)"
              style="cursor: pointer"
            >
              <div class="plate_right_item_content_item">
                <img :src="getFullUrl(item.img)" alt="" />
              </div>
            </div>
          </div>
          <div
            class="plate_right"
            style="display: flex; gap: 10px; flex-direction: column"
          >
            <div class="plate_right_item">
              <div class="plate_right_item_title">
                <span>品牌官说</span>
              </div>
              <div class="plate_right_item_content" v-if="guanShuo[0]">
                <div class="plate_right_item_content_item">
                  <img :src="getFullUrl(guanShuo[0].cover_img)" alt="" />
                </div>
              </div>
            </div>
            <div class="main_plate_news">
              <span
                v-for="item in guanShuo"
                :key="item.id"
                :class="item.is_bold === 1 ? 'news2' : 'news1'"
                @click="goToDetail(item.id)"
              >
                {{ item.title }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackToTop from "../components/BackToTop.vue";
import { getAboutDetail } from "../api";
import { imgBaseURL } from "@/api/index";
export default {
  name: "BilingualNews",
  components: {
    BackToTop,
  },
  data() {
    return {
      activeName: "",
      topClassList: [],
      richTextContent: {},
      coverImgMap: {},
      classSonList: [],
      guanShuo: [],
      currentClassSonId: "",
    };
  },
  mounted() {
    const id = this.$route.query.id;
    this.fetchAboutDetail(id ? Number(id) : "");
  },
  methods: {
    handleClick(tab) {
      const classSonId = Number(tab.name);
      if (classSonId) {
        this.currentClassSonId = classSonId;
        this.fetchAboutDetail(classSonId);
      }
    },
    getFullUrl(path) {
      if (!path) return "";
      return path.startsWith("http") ? path : imgBaseURL + path;
    },
    async fetchAboutDetail(classSonId = "") {
      try {
        const res = await getAboutDetail(classSonId);
        if (res.code === 1 && res.data) {
          const data = res.data;

          // 如果有 top_class_list，保存并设置默认 tab
          if (data.top_class_list && data.top_class_list.length > 0) {
            this.topClassList = data.top_class_list;
            // 如果没有传入 classSonId，使用第一个的 id
            if (!classSonId) {
              classSonId = data.top_class_list[0].id;
            }
            // 设置 activeName 切换到对应的 tab
            this.activeName = String(classSonId);
          }

          this.classSonList = data.class_son_list || [];
          this.guanShuo = data.guan_shuo || [];

          // 保存富文本内容和封面图片（数据在 data.news 中）
          const newsData = data.news || {};
          if (classSonId) {
            this.richTextContent[classSonId] = newsData.content || "";
            this.coverImgMap[classSonId] = newsData.cover_img || "";
          }
        }
      } catch (error) {
        console.error("获取关于我们详情失败:", error);
      }
    },
    goToClassSon(item) {
      if (item.url) {
        window.open(item.url, "_blank");
      } else if (item.id) {
        this.currentClassSonId = item.id;
        this.fetchAboutDetail(item.id);
      }
    },
    goToDetail(id) {
      if (id) {
        window.open(this.$router.resolve({ name: "NewsDetail", params: { id } }).href, '_blank');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.bilingual-news {
  // min-height: 100vh;
  // padding: 40px 0;
  background: #f2f2f2;
  // 重置 h1 的默认样式
  h1 {
    margin: 0;
    padding: 0;
    font-weight: normal;
    font-size: inherit;
  }

  .container {
    max-width: 76rem;
    margin: 0 auto;
  }
  .main_plate_news {
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-width: 446px;
    span {
      width: 100%;
      display: -webkit-box; /* 1. 将对象作为弹性伸缩盒子模型显示 */
      -webkit-line-clamp: 1; /* 2. 限制块元素显示的行数（这里是1行） */
      line-clamp: 1;
      -webkit-box-orient: vertical; /* 3. 设置或检索伸缩盒对象的子元素的排列方式 */
      overflow: hidden; /* 4. 隐藏超出部分 */
      // text-overflow: ellipsis; /* 5. 用省略号代替隐藏部分（配合hidden使用） */
    }
    .news1 {
      font-family: MicrosoftYaHei;
      font-size: 16px;
      color: #424242;
      cursor: pointer;
    }
    .news2 {
      font-family: MicrosoftYaHei;
      font-size: 16px;
      color: #424242;
      font-weight: bold;
      cursor: pointer;
    }
  }

  ::v-deep .el-tabs {
    width: 100%;
  }
  ::v-deep .el-tabs__nav-wrap::after {
    background-color: transparent !important;
  }
  ::v-deep .el-tabs__header {
    margin: 0 0 24px;
    background: #fff;
  }
  ::v-deep .el-tabs__nav-scroll {
    overflow-x: auto;
    overflow-y: hidden;
    padding: 0 20px;
  }
  ::v-deep .el-tabs__nav {
    background: #fff;
    display: flex;
    flex-wrap: nowrap;
    width: max-content;
    min-width: 100%;
  }
  ::v-deep .el-tabs__item {
    font-family: SourceHanSansSC, SourceHanSansSC;
    font-weight: 500;
    color: #030303;
    padding: 0 24px;
    text-align: center;
    font-size: 17px;
    white-space: nowrap;
    flex-shrink: 0;
  }
  ::v-deep .el-tabs__item.is-active {
    color: #ae0000;
  }
  ::v-deep .el-tabs__item:hover {
    color: #ae0000;
  }
  ::v-deep .el-tabs__active-bar {
    background-color: #ae0000;
  }

  @media (max-width: 768px) {
    ::v-deep .el-tabs__nav-scroll {
      padding: 0 12px;
    }
    ::v-deep .el-tabs__item {
      padding: 0 16px;
      font-size: 15px;
    }
  }
  @media (max-width: 480px) {
    ::v-deep .el-tabs__nav-scroll {
      padding: 0 10px;
    }
    ::v-deep .el-tabs__item {
      padding: 0 12px;
      font-size: 14px;
    }
  }
  .main {
    display: flex;
    justify-content: space-between;
    padding-bottom: 146px;
    box-sizing: border-box;
    padding-top: 48px;
    padding-left: 30px;
    .main_left {
      width: 70%;
      display: flex;
      flex-direction: column;
      gap: 10px;
      .main_left_item {
        display: flex;
        flex-direction: column;
        img {
          width: 100%;
          height: 363px;
          object-fit: cover;
        }
        .fu_text {
          width: 100%;
          font-family: SourceHanSansSC, SourceHanSansSC;
          font-weight: 400;
          font-size: 16px;
          color: #2d2c2d;
          padding: 59px 62px 90px 69px;
          background: #fff;
          word-wrap: break-word;
          word-break: break-all;
          line-height: 1.8;

          // 富文本内容样式
          :deep(p) {
            margin: 0 0 16px 0;
            line-height: 1.8;
          }

          :deep(img) {
            max-width: 100%;
            height: auto;
            display: block;
            margin: 16px 0;
          }

          :deep(h1),
          :deep(h2),
          :deep(h3),
          :deep(h4),
          :deep(h5),
          :deep(h6) {
            margin: 20px 0 16px 0;
            font-weight: 500;
            line-height: 1.5;
          }

          :deep(ul),
          :deep(ol) {
            margin: 16px 0;
            padding-left: 24px;
          }

          :deep(li) {
            margin: 8px 0;
            line-height: 1.8;
          }

          :deep(a) {
            color: #ae0000;
            text-decoration: none;
            &:hover {
              text-decoration: underline;
            }
          }

          :deep(table) {
            width: 100%;
            max-width: 100%;
            border-collapse: collapse;
            margin: 16px 0;
            overflow-x: auto;
            display: block;

            th,
            td {
              border: 1px solid #ddd;
              padding: 8px;
              text-align: left;
            }
          }
        }
      }
    }
    .main_right {
      width: 27%;
      display: flex;
      flex-direction: column;
      gap: 30px;
      .plate_right_item {
        display: flex;
        flex-direction: column;
        .plate_right_item_title {
          margin-bottom: 20px;
          span {
            font-family: SourceHanSansCN, SourceHanSansCN;
            font-weight: 500;
            font-size: 20px;
            color: #000000;
          }
        }
        .plate_right_item_content {
          display: flex;
          gap: 10px;
          .plate_right_item_content_item {
            width: 100%;
            img {
              width: 100%;
              height: 169px;
            }
          }
        }
      }
    }
  }

  // 平板响应式 (768px - 1024px)
  @media screen and (max-width: 1024px) and (min-width: 768px) {
    .container {
      padding: 0 20px;
    }

    .main {
      padding-left: 20px;
      padding-top: 30px;
      padding-bottom: 80px;
      flex-direction: column;
      gap: 30px;

      .main_left {
        width: 100%;

        .main_left_item {
          img {
            height: 280px;
          }

          .fu_text {
            padding: 40px 30px 60px 30px;
            font-size: 15px;
          }
        }
      }

      .main_right {
        width: 100%;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 20px;

        .plate_right_item {
          flex: 1;
          min-width: calc(50% - 10px);

          .plate_right_item_title {
            span {
              font-size: 18px;
            }
          }

          .plate_right_item_content {
            .plate_right_item_content_item {
              img {
                height: 140px;
              }
            }
          }
        }

        .plate_right {
          width: 100%;
          flex-direction: row;
          gap: 20px;

          .plate_right_item {
            flex: 1;
          }

          .main_plate_news {
            flex: 1;
            max-width: none;
          }
        }
      }
    }

    ::v-deep .el-tabs__active-bar {
      left: 0;
      width: 25% !important;
    }
  }

  // 移动端响应式 (< 768px)
  @media screen and (max-width: 767px) {
    .container {
      padding: 0 15px;
    }

    .main {
      padding-left: 0;
      padding-top: 20px;
      padding-bottom: 60px;
      flex-direction: column;
      gap: 20px;

      .main_left {
        width: 100%;

        .main_left_item {
          img {
            height: 200px;
          }

          .fu_text {
            padding: 20px 15px 40px 15px;
            font-size: 14px;
            line-height: 1.6;

            :deep(p) {
              margin: 0 0 12px 0;
              line-height: 1.6;
            }

            :deep(img) {
              margin: 12px 0;
            }

            :deep(h1),
            :deep(h2),
            :deep(h3),
            :deep(h4),
            :deep(h5),
            :deep(h6) {
              margin: 16px 0 12px 0;
              font-size: 18px;
            }

            :deep(ul),
            :deep(ol) {
              padding-left: 20px;
            }
          }
        }
      }

      .main_right {
        width: 100%;
        gap: 20px;

        .plate_right_item {
          .plate_right_item_title {
            margin-bottom: 15px;

            span {
              font-size: 16px;
            }
          }

          .plate_right_item_content {
            .plate_right_item_content_item {
              img {
                height: 120px;
              }
            }
          }
        }

        .plate_right {
          flex-direction: column;
          gap: 15px;

          .main_plate_news {
            max-width: 100%;

            .news1 {
              font-size: 14px;
            }
          }
        }
      }
    }

    ::v-deep .el-tabs__header {
      margin: 0 0 20px;
    }

    ::v-deep .el-tabs__item {
      font-size: 14px;
      padding: 0 8px;
    }

    ::v-deep .el-tabs__active-bar {
      left: 0;
      width: 25% !important;
    }
  }
}
</style>
